export default __webpack_public_path__ + "static/media/question-circle-icon.7e6be747.svg";